"use client"

import { cn } from "../lib/utils"
import { Menu } from "./icons"
import { SourcesToggleButton } from "./sources-toggle-button"

// Mock UI components
const Button = ({ children, className, onClick, variant, size, ...props }: any) => (
  <button
    className={cn(
      "px-4 py-2 rounded font-medium focus:outline-none",
      variant === "ghost" && "bg-transparent hover:bg-zinc-700/50",
      size === "icon" && "p-2 aspect-square",
      className,
    )}
    onClick={onClick}
    {...props}
  >
    {children}
  </button>
)

interface ChatHeaderProps {
  chatName: string
  vehicle: string
  onToggleSidebar: () => void
  onToggleSources?: () => void
  sourcesOpen?: boolean
  sourcesCount?: number
}

export function ChatHeader({ 
  chatName, 
  vehicle, 
  onToggleSidebar, 
  onToggleSources, 
  sourcesOpen = false, 
  sourcesCount = 0 
}: ChatHeaderProps) {
  return (
    <header className="border-b border-zinc-800 p-3 md:p-4 bg-zinc-900/50 backdrop-blur-sm">
      <div className="flex items-center justify-between md:flex-row">
        <div className="flex items-center flex-1 min-w-0">
          <Button variant="ghost" size="icon" onClick={onToggleSidebar} className="md:hidden mr-2 flex-shrink-0">
            <Menu />
          </Button>
          <h1 className="text-lg md:text-2xl font-extrabold truncate">{chatName}</h1>
        </div>
        
        <div className="flex items-center gap-2">
          {/* Desktop: Show vehicle name inline */}
          <h3 className="hidden md:block text-lg font-semibold truncate italic text-zinc-400">{vehicle}</h3>
          
          {/* Sources toggle button */}
          {onToggleSources && (
            <SourcesToggleButton
              isOpen={sourcesOpen}
              onToggle={onToggleSources}
              sourcesCount={sourcesCount}
            />
          )}
        </div>
      </div>
      
      {/* Mobile: Show vehicle name on second line with reduced margin */}
      <div className="md:hidden mt-1">
        <h3 className="text-xs font-medium italic text-zinc-400 truncate">{vehicle}</h3>
      </div>
    </header>
  )
}
